<template>
  <div :class="`col-md-4 ${className ? className : ''}`">
    <div class="input-block mb-3">
      <label class="col-form-label">
        {{ label }}
        <span v-if="!notRequired" class="text-danger">*</span>
      </label>

      <Field :name="name" v-model="internalValue" v-slot="{ handleChange }">
        <city-select
          shape="value-label"
          :model-value="internalValue"
          :disabled="disabled"
          :invalid="!!error"
          :placeholder="placeholder"
          :state-id="stateId"
          :country-id="countryId"
          :allow-empty="notRequired"
          @update:model-value="(val) => onChange(val, handleChange)"
        />
      </Field>

      <span v-if="error" class="text-danger">{{ error }}</span>
    </div>
  </div>
</template>

<script>
// Labelled city field for vee-validate forms - the paginated counterpart of
// <CustomSelect2 :options="cities" ...>. v-model is a { value, label } object
// (or null), so it drops into the pages that already keep their city that way.
// Cities come from /city-paginated (loaded as the list is scrolled).
import { Field } from "vee-validate";

export default {
  name: "CityField",

  components: { Field },

  props: {
    modelValue: { type: Object, default: null },
    label: { type: String, default: "City" },
    name: { type: String, required: true },
    error: { type: String, default: "" },
    className: { type: String, default: "" },
    notRequired: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: "Search and select city" },
    // Scope the list to a state / country (e.g. the State select of the same form).
    stateId: { type: [String, Number], default: "" },
    countryId: { type: [String, Number], default: "" },
  },

  emits: ["update:modelValue", "dropdown-value-change"],

  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  watch: {
    // The user picked a different state / country: the chosen city no longer fits.
    // (undefined -> id while a form is being filled in is not a change.)
    stateId(next, prev) {
      this.clearIfScopeChanged(next, prev);
    },
    countryId(next, prev) {
      this.clearIfScopeChanged(next, prev);
    },
  },

  methods: {
    clearIfScopeChanged(next, prev) {
      const had = prev !== "" && prev !== null && prev !== undefined;
      if (had && String(next ?? "") !== String(prev) && this.internalValue) {
        this.internalValue = null;
      }
    },
    onChange(val, handleChange) {
      handleChange(val);
      this.internalValue = val;
      this.$emit("dropdown-value-change", val);
    },
  },
};
</script>
